import request from '@/utils/request'

let SupplierApi = {
  /*供应商列表*/
  supplierList(data, errorback) {
    return request._postBody('/shop/supplier/index', data, errorback);
  },
  /*添加供应商*/
  toaddSupplier(data, errorback) {
    return request._post('/shop/supplier/toAdd', data, errorback);
  },
  /*添加供应商*/
  addSupplier(data, errorback) {
    return request._postBody('/shop/supplier/add', data, errorback);
  },
  /*供应商编辑*/
  toEditSupplier(data, errorback) {
    return request._post('/shop/supplier/toEdit', data, errorback);
  },
  /*供应商编辑*/
  editSupplier(data, errorback) {
    return request._postBody('/shop/supplier/edit', data, errorback);
  },
  /*删除供应商*/
  deleteSupplier(data, errorback) {
    return request._post('/shop/supplier/delete', data, errorback);
  },
  supplierDownload(data, filename,config, errorback) {
    return request._download('/shop/supplier/export/lsy', data, filename, config, errorback);
  },
  /*提现记录*/
  cashList(data, errorback) {
    return request._postBody('/shop/supplier/cash/index', data, errorback);
  },
  /*提现审核*/
  cashSubmit(data, errorback) {
    return request._postBody('/shop/supplier/cash/submit', data, errorback);
  },
  /*提现确认打款*/
  cashMoney(data, errorback) {
    return request._post('/shop/supplier/cash/money', data, errorback);
  },
  /*供应商待审核列表*/
  supplierPendList(data, errorback) {
    return request._postBody('/shop/supplier/apply', data, errorback);
  },
  /*获取主营分类*/
  Category(data, errorback) {
    return request._post('/shop/supplier/category/index', data, errorback);
  },
    /*添加分类*/
    addCategory(data, errorback) {
    return request._postBody('/shop/supplier/category/add', data, errorback);
  },
    /*编辑分类*/
  editCategory(data, errorback) {
    return request._postBody('/shop/supplier/category/edit', data, errorback);
  },
    /*删除分类*/
    deleteCategory(data, errorback) {
    return request._post('/shop/supplier/category/delete', data, errorback);
  },
  /*服务保障申请列表*/
    securityList(data, errorback) {
    return request._postBody('/shop/supplier/security', data, errorback);
  },
  /*服务保障操作*/
    securityVerify(data, errorback) {
    return request._postBody('/shop/supplier/verify', data, errorback);
  },
    /*获取广告分类*/
    SecurityList(data, errorback) {
    return request._postBody('/shop/supplier/security/index', data, errorback);
  },
    /*添加分类*/
    addSecurity(data, errorback) {
    return request._postBody('/shop/supplier/security/add', data, errorback);
  },
    /*编辑分类*/
    editSecurity(data, errorback) {
    return request._postBody('/shop/supplier/security/edit', data, errorback);
  },
    /*删除分类*/
    deleteSecurity(data, errorback) {
    return request._post('/shop/supplier/security/delete', data, errorback);
  },
  /*开启禁止*/
    supplierRecycle(data, errorback) {
    return request._post('/shop/supplier/recycle', data, errorback);
  },

  /*子商户申请列表*/
  applymentList(data, errorback) {
    return request._postBody('/shop/supplier/applyment/index', data, errorback);
  },
  /*添加子商户申请*/
  addApplyment(data, errorback) {
    return request._postBody('/shop/supplier/applyment/add', data, errorback);
  },
  checkWxApplyment(data, errorback) {
    return request._postBody('/shop/supplier/applyment/wx/check', data, errorback);
  },
  checkAlipayApplyment(data, errorback) {
    return request._postBody('/shop/supplier/applyment/alipay/check', data, errorback);
  },
  checkLakalaApplyment(data, errorback) {
    return request._postBody('/shop/supplier/applyment/lakala/check', data, errorback);
  },
  replenishFileLakala(data, errorback) {
    return request._postBody('/shop/supplier/applyment/lakala/replenish', data, errorback);
  },
  reconsiderSubmit(data, errorback) {
    return request._postBody('/shop/supplier/applyment/lakala/reconsiderSubmit', data, errorback);
  },
  checkApplymentStatus(data, errorback) {
    return request._get('/shop/supplier/applyment/checkStatus', data, errorback);
  },
  /*子商户申请详情*/
  applymentDetail(data, errorback) {
    return request._get('/shop/supplier/applyment/toEdit', data, errorback);
  },
  /*修改子商户申请*/
  editApplyment(data, errorback) {
    return request._postBody('/shop/supplier/applyment/edit', data, errorback);
  },
  /*修改子商户申请*/
  changeRate(data, errorback) {
    return request._postBody('/shop/supplier/applyment/lakala/changeRate', data, errorback);
  },
  /*删除子商户申请*/
  deleteApplyment(data, errorback) {
    return request._post('/shop/supplier/applyment/delete', data, errorback);
  },
}
export default SupplierApi;



// WEBPACK FOOTER //
// ./src/api/supplier.js